<script setup lang="ts">
import { NModal, NCard } from 'naive-ui';

interface Props {
  modelValue: boolean;
  title: string;
  subtitle?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}

const props = withDefaults(defineProps<Props>(), {
  maxWidth: 'lg',
});

const emit = defineEmits<{
  (e: 'update:modelValue', val: boolean): void;
}>();

const close = () => {
  emit('update:modelValue', false);
};
</script>

<template>
  <NModal
    :show="modelValue"
    @update:show="(val) => emit('update:modelValue', val)"
    transform-origin="center"
    class="w-full"
    :style="{
      maxWidth: maxWidth === 'sm' ? '380px' : maxWidth === 'md' ? '460px' : maxWidth === 'xl' ? '650px' : maxWidth === '2xl' ? '780px' : '540px'
    }"
  >
    <NCard
      :bordered="true"
      size="medium"
      role="dialog"
      aria-modal="true"
      closable
      @close="close"
      class="bg-slate-900 border-slate-800 text-slate-100 shadow-2xl rounded-2xl"
    >
      <template #header>
        <div>
          <h3 class="text-base sm:text-lg font-extrabold text-slate-100 tracking-tight">{{ title }}</h3>
          <p v-if="subtitle" class="mt-0.5 text-xs text-slate-400 font-normal">{{ subtitle }}</p>
        </div>
      </template>

      <div>
        <slot />
      </div>

      <template v-if="$slots.footer" #footer>
        <slot name="footer" :close="close" />
      </template>
    </NCard>
  </NModal>
</template>